import { LoadState } from '@nx-ng/types';
import { KnownPostcodeTicketVerifyResponseStatus } from '../client/src';
import {
  IPostcodeChildTicketVerifyEntry,
  IPostcodeChildTicketVerifyState,
} from '../reducers/postcode-child-ticket-verify';

export const invalidChildTicketsExist = (
  state: IPostcodeChildTicketVerifyState
): boolean => {
  return Object.values(state).some(
    (ticket: IPostcodeChildTicketVerifyEntry) =>
      ticket.status === KnownPostcodeTicketVerifyResponseStatus.Unverified
  );
};

export const allChildTicketsVerified = (
  state: IPostcodeChildTicketVerifyState,
  childTicketIds: number[]
): boolean | undefined => {
  const allChildIdsInState = Object.keys(state);
  if (allChildIdsInState.length === 0) {
    return undefined;
  }
  return (
    childTicketIds.length === 0 ||
    childTicketIds.every((id: number) => {
      return allChildIdsInState.includes(id.toString());
    })
  );
};

export const childTicketVerifyInProgress = (
  state: IPostcodeChildTicketVerifyState
): boolean => {
  return Object.values(state).some(
    (ticket: IPostcodeChildTicketVerifyEntry) =>
      ticket.loaded === LoadState.LOADING
  );
};
